import { render, staticRenderFns } from "./13QuotaValuation.vue?vue&type=template&id=3c565b74&"
import script from "./13QuotaValuation.vue?vue&type=script&lang=js&"
export * from "./13QuotaValuation.vue?vue&type=script&lang=js&"
import style0 from "./13QuotaValuation.vue?vue&type=style&index=0&id=3c565b74&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports